import { EntityStatusTypes } from "@enums/entity-status-types";
import {
    ApAssertion,
    Assertion,
    ServiceOffering
} from "@idw-types/data/reference-data/generic";
import {
    FormattedRpServiceConfigurationServiceOfferingAssertion,
    RpServiceConfigurationServiceOffering,
    RpServiceConfigurationServiceOfferingAssertion
} from "@idw-types/data/rp-service-configuration";
import { v4 as uuidv4 } from "uuid";

export const formatRpServiceConfigurationServiceOfferingAssertions = (
    rpServiceConfigurationServiceOffering: RpServiceConfigurationServiceOffering,
    serviceOffering: ServiceOffering,
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>
): Array<FormattedRpServiceConfigurationServiceOfferingAssertion> => {
    const finalAssertions: Array<FormattedRpServiceConfigurationServiceOfferingAssertion> = [];

    apAssertions.forEach(apAssertion => {
        const assertion = assertions.find(assertion => assertion.id == apAssertion.assertionID);
        const rpServiceConfigurationServiceOfferingAssertions =
            rpServiceConfigurationServiceOffering?.assertions?.filter(assertion => assertion.apAssertionID === apAssertion.id) || [];

        // need to handle the case where multiple assertions with the same apAssertionID are added to a service
        if (rpServiceConfigurationServiceOfferingAssertions.length > 0) {
            rpServiceConfigurationServiceOfferingAssertions.forEach(rpscsoa => {
                const finalAssertion = formatRpServiceConfigurationServiceOfferingAssertion(
                    serviceOffering,
                    rpscsoa,
                    apAssertion,
                    assertion
                );
                finalAssertions.push(finalAssertion);
            });
        } else {
            const finalAssertion = formatRpServiceConfigurationServiceOfferingAssertion(
                serviceOffering,
                null,
                apAssertion,
                assertion
            );
            finalAssertions.push(finalAssertion);
        }
    });
    return finalAssertions;
};

export const formatRpServiceConfigurationServiceOfferingAssertion = (
    serviceOffering: ServiceOffering,
    rpServiceConfigurationServiceOfferingAssertion: RpServiceConfigurationServiceOfferingAssertion,
    apAssertion: ApAssertion,
    assertion: Assertion
): FormattedRpServiceConfigurationServiceOfferingAssertion => {
    return {
        alternateName: assertion.alternateName,
        description: assertion.description,
        assertionId: assertion.id,
        shortName: assertion.shortName,
        assertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.assertionMessageID || null,
        closeAssertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.closeAssertionMessageID || null,
        failAssertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.failAssertionMessageID || null,
        id: rpServiceConfigurationServiceOfferingAssertion?.id || null,
        partialAssertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.partialAssertionMessageID || null,
        passAssertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.passAssertionMessageID || null,
        serviceOfferingID: serviceOffering.id || null,
        status: rpServiceConfigurationServiceOfferingAssertion?.status || EntityStatusTypes.INACTIVE,
        unverifiedAssertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.unverifiedAssertionMessageID || null,
        warnAssertionMessageID: rpServiceConfigurationServiceOfferingAssertion?.warnAssertionMessageID || null,
        apAssertionId: apAssertion.id,
        apAssertionStatus: apAssertion.status || EntityStatusTypes.INACTIVE,
        addedToService: !!rpServiceConfigurationServiceOfferingAssertion,
        uuid: uuidv4()
    };
};